import { useMutation } from 'react-query'
import { uploadFile } from '../services/uploadFile';

export function useUploadFile() {
    return useMutation((data: any) => uploadFile(data));
}